export class VenueResponseModel {
    id!: number;
    companyId!: number;
    name?: string;
    description?: string;
    address?: string;
    city?: string;
}
